import { Button } from '../../../Utility/Button';
import AdminViewHeader from '../../../Utility/AdminViewHeader';
import AdminViewContent from '../../../Utility/AdminViewContent';
import { EmbeddingModel } from '../../../../Types';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import { PaginationWrapper } from '../../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { embeddingModelService } from '../../../../Services/embeddingModelService';
import useEmbeddingModels from '../../../../Hooks/useEmbeddingModels';
import useGlobals from '../../../../Hooks/useGlobals';
import useSearchFilter from '../../../../Hooks/useSearchFilter';
import SearchFilter from '../../../Utility/SearchFilter';

function ChatModels() {
    const { settings, userSettings } = useGlobals();
    const { ModelsActions, handleNavigate, i18n, windowWidth, getBreakpoint } = useEmbeddingModels();
    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';

    return (
        <>
            <SearchFilter
                value={localQuery}
                onChange={searchActions.setLocalQuery}
                onApply={searchActions.applyQuery}
                onClear={searchActions.clearQuery}
            />
            <div className="mb-4 md:hidden">
                {(!settings.demo || userSettings.isSuperAdmin) && (
                    <Button className="w-full mb-2" onClick={() => handleNavigate('/admin/embeddingmodels/new')}>
                        {i18n.translate({ id: 'button', sourceName: 'EmbeddingModels' })}
                    </Button>
                )}
            </div>
            <div className="hidden md:block">
                <AdminViewHeader
                    gridCols={GRID_COLS}
                    cols={{
                        cols: [
                            {
                                text: i18n.translate({ id: 'adminHeader.mainCol', sourceName: 'Main' }),
                            },
                        ],
                        button:
                            !settings.demo || userSettings.isSuperAdmin
                                ? {
                                      text: i18n.translate({ id: 'button', sourceName: 'EmbeddingModels' }),
                                      function: () => handleNavigate('/admin/embeddingmodels/new'),
                                  }
                                : undefined,
                    }}
                />
                <hr className="border-layout-borderColor mt-5" />
            </div>
            <PaginationWrapper
                listType={PaginationListType.EmbeddingModels}
                itemsFunction={embeddingModelService.getModelsByPage}
                itemsPerPage={15}
                query={query || null}
                renderItem={(model: EmbeddingModel, index: number) => (
                    <AdminViewContent
                        key={model.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={model.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: model.title,
                                    image: model.image,
                                    showImage: true,
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        variant: 'primaryRound',
                                        onClick: () => handleNavigate(`/admin/embeddingmodels/${model.identifier}`),
                                        icon: <PencilSimple />,
                                    },
                                    {
                                        variant:
                                            model.identifier === settings.embeddingModel
                                                ? 'disabledRound'
                                                : 'secondaryRound',
                                        onClick: () =>
                                            model.identifier === settings.embeddingModel
                                                ? null
                                                : ModelsActions.handleOpenConfirmDialog(model.identifier),
                                        icon: <Trash />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            />
        </>
    );
}

export default ChatModels;
